__turbopack_context__.v({
  "card": "EcosystemProductsSection-module__oqNYrG__card",
  "cardContent": "EcosystemProductsSection-module__oqNYrG__cardContent",
  "cardSubtitle": "EcosystemProductsSection-module__oqNYrG__cardSubtitle",
  "cardTitle": "EcosystemProductsSection-module__oqNYrG__cardTitle",
  "grid": "EcosystemProductsSection-module__oqNYrG__grid",
  "image": "EcosystemProductsSection-module__oqNYrG__image",
  "imageWrap": "EcosystemProductsSection-module__oqNYrG__imageWrap",
  "insetBorder": "EcosystemProductsSection-module__oqNYrG__insetBorder",
  "section": "EcosystemProductsSection-module__oqNYrG__section" + " " + __turbopack_context__.i(46473)["sectionPadding"],
  "title": "EcosystemProductsSection-module__oqNYrG__title",
});
